export default "__VITE_ASSET__Dld_HNLj__"